import React,{useContext,createContext,useState,useEffect} from "react"
import Header from "./Header";
import TopPanel from "./TopPanel";
import CenterPanel from "./CenterPanel";
import Footer from "./Footer";
import AppContext from "./AppContext";

import LoginScreen from "./LoginScreen";
import LoadingMask from "./LoadingMask";
import Api from "./Api";
import YearMonthSelector from "./YearMonthSelector";
import { useGlobal } from "./Reducer";
import Alert from "./Alert";
import BooleanAlert from "./BooleanAlert";
import queryString from "query-string";
import DownLogos from "./DownLogos";

 
 
    export default(props)=>
    {
      const nowDate=new Date();
      const [globalState, globalActions] = useGlobal();
      const [year,setYear]=useState(nowDate.getFullYear());
    
      nowDate.setMonth(nowDate.getMonth()+1)
      const [_month,setMonth]=useState(nowDate.getMonth()+1);


      const isLoggedIn=Api.isUserLoggedIn();

       useEffect(()=>{
        // debugger;
        const {accessToken,month}=queryString.parse(props.location.search, { ignoreQueryPrefix: true }) 
        if(month)
        {
          const [am,yy]=Api.getParts(month);
          setMonth(am)
          setYear(yy);

        }  

        globalActions.setAdminMode(isLoggedIn);
       },[])
    
        return (
      
        
        <div style={{backgroundColor:"#ffffff"}}  >
          <BooleanAlert  
              isOpen={globalState.bool.show}
              message={globalState.bool.message}
              title={globalState.bool.title}
              yes={globalState.bool.yes}
              no={globalState.bool.no}   
          
          />
<Alert isOpen={globalState.alert.show}
            message={globalState.alert.message}
            title={globalState.alert.title}
            onClose={globalActions.hideAlert}
            />
            <LoadingMask isOpen={globalState.loading}/>
                   {isLoggedIn==false && <LoginScreen/>}
                   {isLoggedIn==true && <React.Fragment>     <div >
                    <YearMonthSelector month={_month} year={year} />

        <Header/>
      
                    <TopPanel/>
                    <CenterPanel/>
                    <DownLogos/>
                    <Footer/>
        </div></React.Fragment>}
        </div>
      );
    }


